﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const app_commons_1 = require("@its-suite/app-commons");
const form_controls_1 = require("@its-suite/form-controls");
const operational_context_client_1 = require("@its-suite/operational-context-client");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const components_1 = require("../../components");
const redux_2 = require("../../redux");
const prefixDivider = '-';
class ExtendedFieldsContainerInternal extends React.Component {
    constructor(props) {
        super(props);
        this.loadData = () => {
            let apiClient = operational_context_client_1.OperationalContextClientFactory.getExtendedAttributeClient(this.props.microserviceUrl);
            const requests = this.props.entityNames.map((entity) => apiClient.getGlobalAttributes(entity.name));
            Promise.all(requests).then(resolvedRequests => {
                resolvedRequests.forEach((attributes) => {
                    let entityFields = [];
                    attributes.forEach((attribute) => {
                        let type = this.getFormFieldTypeForAttribute(attribute);
                        let selectOptions;
                        if (type === components_1.FormFieldType.Select) {
                            selectOptions = attribute.enumValues;
                        }
                        entityFields.push(new components_1.FormFieldDefinition({
                            type: type,
                            name: `${attribute.entityName}${prefixDivider}${attribute.attributeName}`,
                            visibleName: this.props.translate(attribute.resourceName),
                            validatorList: this.getValidatorForAttribute(attribute),
                            selectOptions: selectOptions,
                            disabled: this.isEntityDisabled(attribute.entityName)
                        }));
                    });
                    this.setState((oldState) => ({ fields: [...oldState.fields, ...entityFields] }));
                });
                this.setState({ loading: false });
            }).catch((exception) => {
                this.setState({ loading: false });
                this.props.showSnackbar(exception.response);
            });
        };
        this.onChange = (values) => {
            const result = [];
            for (const entity of this.props.entityNames) {
                result.push({ entityName: entity.name, attributes: new Map() });
            }
            const valuesKeys = Object.keys(values);
            for (const valueKey of valuesKeys) {
                const [entity, attribute] = valueKey.split(prefixDivider);
                const entityAtributteEntry = result.find((entityAttribute) => entityAttribute.entityName === entity);
                entityAtributteEntry.attributes.set(attribute, values[valueKey]);
            }
            this.props.onChange(result);
        };
        this.isEntityDisabled = (entityName) => {
            return this.props.entityNames.find((item) => item.name === entityName).disabled;
        };
        this.didDisabledChange = (entityNames) => {
            let didChange = false;
            entityNames.forEach((oldEntityName) => {
                const wasDisabled = oldEntityName.disabled;
                const isDisabled = this.props.entityNames.find((entiyName) => entiyName.name === oldEntityName.name).disabled;
                didChange = didChange || wasDisabled !== isDisabled;
            });
            return didChange;
        };
        this.plainValuesToEdit = () => {
            if (this.props.valuesToEdit) {
                return this.props.valuesToEdit
                    .filter(value => this.props.entityNames.some(entity => entity.name === value.entityName))
                    .reduce((accum, current) => {
                    let entityExtendedValues = {};
                    current.attributes.forEach((value, key) => {
                        const prefixedKey = `${current.entityName}${prefixDivider}${key}`;
                        entityExtendedValues = Object.assign(Object.assign({}, entityExtendedValues), { [prefixedKey]: value });
                    });
                    return Object.assign(Object.assign({}, accum), entityExtendedValues);
                }, {});
            }
            return {};
        };
        this.state = {
            loading: true,
            fields: []
        };
    }
    componentDidMount() {
        this.loadData();
    }
    componentDidUpdate(oldProps) {
        let shouldUpdateDisabledFields = this.didDisabledChange(oldProps.entityNames);
        if (shouldUpdateDisabledFields) {
            const fields = this.state.fields;
            const updatedFields = fields.map((field) => {
                const fieldEntity = field.name.split(prefixDivider)[0];
                return Object.assign(Object.assign({}, field), { disabled: this.isEntityDisabled(fieldEntity) });
            });
            this.setState({ fields: updatedFields });
        }
    }
    render() {
        let content = null;
        if (this.state.loading) {
            content = React.createElement(form_controls_1.CircularProgress, null);
        }
        else {
            content = (React.createElement(components_1.ExtendedFields, { fields: this.state.fields, texts: { legend: this.props.translate('ExtendedFields') }, valuesToEdit: this.plainValuesToEdit(), onChange: this.onChange }));
        }
        return content;
    }
    getValidatorForAttribute(attribute) {
        let validators = [];
        let validator;
        switch (attribute.valueType) {
            case operational_context_client_1.ValueType.INTEGER:
                validator = new form_controls_1.Validator({ validatorType: form_controls_1.ValidatorTypes.Integer, validatorName: 'validInteger', message: this.props.translate('ErrorIntegerNumber') });
                break;
            case operational_context_client_1.ValueType.DOUBLE:
                validator = new form_controls_1.Validator({ validatorType: form_controls_1.ValidatorTypes.Double, validatorName: 'validFloat', message: this.props.translate('ErrorDecimalNumber') });
                break;
        }
        if (validator) {
            validators.push(validator);
        }
        return validators;
    }
    getFormFieldTypeForAttribute(attribute) {
        switch (attribute.valueType) {
            case operational_context_client_1.ValueType.INTEGER:
                return components_1.FormFieldType.Text;
            case operational_context_client_1.ValueType.DOUBLE:
                return components_1.FormFieldType.Text;
            case operational_context_client_1.ValueType.STRING:
                return components_1.FormFieldType.Text;
            case operational_context_client_1.ValueType.DATETIME:
                return components_1.FormFieldType.DateTime;
            case operational_context_client_1.ValueType.BOOLEAN:
                return components_1.FormFieldType.Boolean;
            case operational_context_client_1.ValueType.ENUM:
                return components_1.FormFieldType.Select;
            default:
                throw new Error(('Invalid attribute data type'));
        }
    }
}
exports.ExtendedFieldsContainerInternal = ExtendedFieldsContainerInternal;
ExtendedFieldsContainerInternal.defaultProps = {
    microserviceUrl: operational_context_client_1.OperationalContextClientConfiguration.getBaseUrl(),
};
function mapStateToProps(state) {
    return {
        translate: state.translate,
        isSuperAdmin: redux_2.SessionSelector.isSuperAdmin(state)
    };
}
function mapDispatchToProps(dispatch) {
    return redux_1.bindActionCreators({
        showSnackbar: app_commons_1.MessagesActions.actionCreators.triggerShowExceptionMessage
    }, dispatch);
}
exports.ExtendedFieldsContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExtendedFieldsContainerInternal);
//# sourceMappingURL=ExtendedFieldsContainer.js.map